/**
 * A posição do cliente na fila de espera.
 *
 * Ponto 8 da Gisele (20/10/2026): "se possível, mostrar ao cliente do Chat a
 * posição dele na fila (ex.: '1º aguardando')".
 *
 * ## Por que isto é um módulo
 *
 * `ChatMessages` monta socket, upload e áudio, e não há teste de componente
 * neste repositório. O que pode errar em silêncio aqui são as decisões -- QUANDO
 * perguntar e O QUE escrever --, e é só isso que mora aqui. A requisição e o
 * relógio ficam no componente.
 */

/**
 * De quanto em quanto tempo perguntar, em milissegundos.
 *
 * A fila anda quando um operador pega alguém, não continuamente: perguntar de
 * segundo em segundo gastaria uma requisição por cliente esperando, por
 * segundo, para mostrar o mesmo número. Dez segundos é mais rápido do que
 * qualquer pessoa percebe a fila andar.
 */
export const INTERVALO_DA_CONSULTA = 10000;

/**
 * O cliente está na fila?
 *
 * Só quem está numa conversa ABERTA e ainda SEM operador. Com operador, não há
 * fila; fora da conversa, não há o que perguntar.
 *
 * @param {number} status      o status da tela do chat (1 = conversa aberta)
 * @param {*} operadorId       `roomInfo.operatorId`, vazio enquanto ninguém pegou
 */
export const estaNaFila = (status, operadorId) => {
    if (Number(status) !== 1) return false;

    return operadorId == null || operadorId === '' || Number(operadorId) === 0;
};

/**
 * O texto mostrado ao cliente.
 *
 * `null` quando não há o que dizer -- posição ausente, zero ou negativa. A
 * tela não mostra nada nesse caso: uma tarja vazia, ou "0º aguardando",
 * assusta mais do que silêncio.
 *
 * O primeiro da fila ganha uma frase própria. "1º aguardando" é literalmente o
 * exemplo do pedido, mas quem está em primeiro quer saber que é o próximo, e
 * essa é a informação que o número sozinho não dá.
 */
export const textoDaPosicao = (posicao) => {
    const n = Number(posicao);

    if (!Number.isFinite(n) || n < 1) return null;

    if (n === 1) return 'Você é o próximo a ser atendido (1º aguardando).';

    return `Você é o ${n}º aguardando na fila.`;
};
